import axios from 'axios'
import { getToken, removeToken, getUserId } from './auth'
import { addErrorLog, ErrorType, ErrorLevel, getFriendlyErrorMessage } from './errorHandler'
import { ElMessage, ElMessageBox } from 'element-plus'

const axiosInstance = axios.create({
  baseURL: '',
  timeout: 30000,
  method: 'get',
  retry: 2,
  retryDelay: 1000
})

// 请求拦截器
axiosInstance.interceptors.request.use(
  config => {
    if (typeof config !== 'object' || config === null) config = {}
    if (typeof config.method !== 'string') config.method = 'get'
    if (typeof config.url !== 'string') config.url = ''
    if (typeof config.headers !== 'object' || config.headers === null) config.headers = {}

    const token = getToken()
    // 微信授权等第三方接口不携带 token
    if (token && !config.url.startsWith('/api/third/')) {
      config.headers.Authorization = 'Bearer ' + token
    }

    const userId = getUserId()
    // 微信授权等第三方接口不携带 userId
    if (userId && !config.url.startsWith('/api/third/')) {
      config.headers['X-User-Id'] = userId
    }

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }

    return config
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器 ———— 🔥🔥🔥 这里完全修复
axiosInstance.interceptors.response.use(
  response => {
    const res = response?.data ?? {}

    // ==============================
    // 关键修复：支持 success 格式
    // ==============================
    if (res.success === true || res.code === 200 || res.code === 0) {
      return res
    }

    const errorMsg = res.msg || res.message || '请求失败'
    console.warn('接口异常：', errorMsg)

    // ==============================
    // 登录接口不再静默、不再自动弹框
    // ==============================
    const url = response.config?.url || ''
    if (url.includes('/api/auth/login')) {
      return Promise.reject(new Error(errorMsg))
    }

    ElMessage.error(errorMsg)
    return Promise.reject(new Error(errorMsg))
  },
  error => {
    const url = error.config?.url || ''

    // ==============================
    // 登录接口：只 reject，不弹窗
    // ==============================
    if (url.includes('/api/auth/login')) {
      return Promise.reject(error)
    }

    if (url.includes('/api/message/unread/count')) {
      console.error('获取未读消息数量失败:', error.response?.status, error.message)
      return Promise.resolve({ code: 200, msg: 'success', data: { total: 0, system: 0, friend_request: 0 } })
    }

    const msg = getFriendlyErrorMessage(error)
    ElMessage.error(msg)

    if (error.response?.status === 401) {
      ElMessageBox.confirm('登录已过期，请重新登录', '提示', {
        confirmButtonText: '去登录'
      }).then(() => {
        removeToken()
        location.reload()
      })
    }

    return Promise.reject(error)
  }
)

export default function request(config) {
  if (typeof config !== 'object') config = {}
  const method = (config.method || 'get').toLowerCase()
  let url = config.url || ''

  // 确保 url 以 / 开头
  if (!url.startsWith('/')) {
    url = '/' + url
  }

  // 确保 url 以 /api 开头（如果还没有的话），但 collect 路径特殊处理
  // 注意：不要给已经以 /api 开头的URL重复添加 /api 前缀
  if (!url.startsWith('/api') && !url.startsWith('/collect')) {
    url = '/api' + url
  }

  const finalConfig = {
    ...config,
    method,
    url,
    headers: config.headers || {},
    params: config.params || {},
    data: config.data || {}
  }

  return axiosInstance(finalConfig)
}

export { axiosInstance }